import { ResolveFn } from "@angular/router";
import { IOcrQuotation } from "../../../../../shared/ocr-quotation/interfaces/ocr-quotation.interface";
import { inject } from "@angular/core";
import { OcrQuotationApiService } from "../services/ocr-quotation-api.service";

export const ocrQuotationResolver: ResolveFn<IOcrQuotation> = route => {
  const ocrQuotationApiService = inject(OcrQuotationApiService);
  return ocrQuotationApiService.fetchOcrQuotation(route.paramMap.get("id")!);
};
